import Spinner from "./views/appSpinner";

export default {
  install(Vue) {
    Vue.component("appLoader", Spinner);
  },
};
